import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import i18n from '@/lang/lang';
import Multiselect from 'vue-multiselect';
import { projectSolarSiteinfoChildrenRoutes } from '@/router/routes';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  name: 'SiteInfo',
  components: {
    Multiselect: Multiselect
  },
  data: function data() {
    return {
      // liveEvent: false,
      routeQuery: {},
      marqueeMsg: '',
      selectedFactoryName: ''
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['factoryInfo', 'factoryData', 'hasRoleAdmin', 'userDetail', 'roleComponentMenu'])), mapGetters(['getFactoryInfoNameList'])), {}, {
    routeName: function routeName() {
      return this.$route.name;
    },
    isForeignSite: function isForeignSite() {
      return this.routeQuery.foreign === 'true';
    },
    isDemoSite: function isDemoSite() {
      return this.routeQuery.demo === 'true';
    },
    navbarList: function navbarList() {
      var _this = this;
      if (this.isDemoSite) {
        return projectSolarSiteinfoChildrenRoutes.filter(function (route) {
          return _this.roleComponentMenu.includes(route.name) && route.meta.demoSite;
        }).map(function (_ref) {
          var name = _ref.name,
            meta = _ref.meta;
          return {
            name: name,
            zhTw: meta.zhTw,
            icon: meta.icon
          };
        });
      } else if (this.isForeignSite) {
        return projectSolarSiteinfoChildrenRoutes.filter(function (route) {
          return _this.roleComponentMenu.includes(route.name) && route.meta.foreignSite;
        }).map(function (_ref2) {
          var name = _ref2.name,
            meta = _ref2.meta;
          return {
            name: name,
            zhTw: meta.zhTw,
            icon: meta.icon
          };
        });
      } else {
        return projectSolarSiteinfoChildrenRoutes.filter(function (route) {
          return _this.roleComponentMenu.includes(route.name);
        }).map(function (_ref3) {
          var name = _ref3.name,
            meta = _ref3.meta;
          return {
            name: name,
            zhTw: meta.zhTw,
            icon: meta.icon
          };
        });
      }
    }
  }),
  watch: {
    '$route.query': function $routeQuery(to, from) {
      // fix toSiteInfo 網址有變化 但頁面沒有載入問題
      // fix 若使用 this.$router.go(0) 返回上一頁，網址沒有變化
      if (to.siteName !== from.siteName) {
        window.location.reload();
      }
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations(['UPDATE_DATA_ANALYSIS_STATE', 'ADD_QUERY_SITE_NAME'])), mapActions(['asyncSpecificLastDoc'])), {}, {
    copyToClipboard: function copyToClipboard(text) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText(text);
              case 3:
                _this2.$swal('複製成功');
                _context.next = 9;
                break;
              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                console.error('Failed to copy: ', _context.t0);
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }))();
    },
    handleSelectFactoryName: function handleSelectFactoryName(selectedFactoryName) {
      this.goToSingleSiteInfo(selectedFactoryName);
    },
    handleOpenFactoryNameSelection: function handleOpenFactoryNameSelection() {
      var _this3 = this;
      // selection open，捲軸移至已選選項
      this.$nextTick(function () {
        var multiselect = _this3.$refs.multiselectRef.$el;
        var selected = multiselect.querySelector('.multiselect__option--selected');
        var dropdown = multiselect.querySelector('.multiselect__content-wrapper');
        if (selected && dropdown) {
          dropdown.scrollTop = selected.offsetTop;
          // dropdown.scrollTop = selected.offsetTop - dropdown.offsetTop
        }
      });
    },
    tooltipDisplaySiteName: function tooltipDisplaySiteName(isDemo) {
      if (isDemo === 'true') {
        var demoIndex = this.routeQuery.siteName.split(' ')[1] - 1;
        return this.factoryInfo[demoIndex].factory;
      }
    },
    goToSingleSiteInfo: function goToSingleSiteInfo(selectedFactoryName) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _singleData$0$Eff$len, _singleData$0$Eff;
        var querySiteDataArr, singleData, _singleData$, factoryId, isDemoSite, invLen, pvLen, anemometerLen, routerQueryParams;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // filter Info 有找到 selectedFactoryName 且 不在展示的 Data 內
                querySiteDataArr = _this4.factoryInfo.filter(function (info) {
                  return info.displaySiteName.includes(selectedFactoryName);
                }).filter(function (info) {
                  return !_this4.factoryData.map(function (data) {
                    return data === null || data === void 0 ? void 0 : data.displaySiteName;
                  }).includes(info.displaySiteName);
                });
                if (!(querySiteDataArr !== null && querySiteDataArr !== void 0 && querySiteDataArr.length)) {
                  _context2.next = 4;
                  break;
                }
                _context2.next = 4;
                return _this4.asyncSpecificLastDoc(querySiteDataArr);
              case 4:
                singleData = _this4.factoryData.filter(function (x) {
                  return x.displaySiteName === selectedFactoryName;
                });
                _singleData$ = singleData[0], factoryId = _singleData$.factoryId, isDemoSite = _singleData$.isDemoSite;
                invLen = (_singleData$0$Eff$len = (_singleData$0$Eff = singleData[0].Eff) === null || _singleData$0$Eff === void 0 ? void 0 : _singleData$0$Eff.length) !== null && _singleData$0$Eff$len !== void 0 ? _singleData$0$Eff$len : 0;
                pvLen = singleData[0].pv_a ? Math.max.apply(Math, _toConsumableArray(singleData[0].pv_a.map(function (x) {
                  return x.length;
                }))) : singleData[0].mppt_a ? Math.max.apply(Math, _toConsumableArray(singleData[0].mppt_a.map(function (x) {
                  return x.length;
                }))) : 0;
                anemometerLen = Array.isArray(singleData[0].Anemometer) ? singleData[0].Anemometer.length : singleData[0].Anemometer || singleData[0].Anemometer === 0 ? 1 : 0;
                routerQueryParams = {
                  siteName: singleData[0].displaySiteName,
                  invLen: invLen,
                  pvLen: pvLen,
                  anemometerLen: anemometerLen,
                  fid: factoryId,
                  demo: isDemoSite ? 'true' : 'false'
                };
                _this4.toSiteInfo(routerQueryParams);
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    toSiteInfo: function toSiteInfo(routerQueryParams) {
      if (this.roleComponentMenu.length) {
        var to = this.roleComponentMenu[0];
        this.$router.push({
          path: "/".concat(i18n.locale, "/siteinfo/").concat(to),
          query: routerQueryParams
        });
      } else {
        this.$swal('權限不足');
        this.$router.push({
          path: "/".concat(i18n.locale, "/realtime")
        });
      }
    }
  }),
  created: function created() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this5.routeQuery = _this5.$route.query;
              _this5.ADD_QUERY_SITE_NAME(_this5.$route.query.siteName);
              _this5.UPDATE_DATA_ANALYSIS_STATE();
              _this5.selectedFactoryName = _this5.routeQuery.siteName;
            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};